import { RPService } from '../services/rp.service'
import { RPI } from '@/core/interfaces/rp.interface'
import { RPGetParamsT, RPItemResponseT, RPResponseT } from '@/core/types/rp.types'

const rpService = new RPService()

class RPRealisation implements RPI {
    generateRP(): Promise<{ message: string }> {
        return rpService.generateRP()
    }

    getList(params: RPGetParamsT): Promise<RPResponseT> {
        return rpService.getList(params)
    }

    getRP(id: number): Promise<RPItemResponseT> {
        return rpService.getRP(id)
    }

    exportRPKListExcel(id: number): Promise<any> {
        return rpService.exportRPKListExcel(id)
    }

    exportRPPListExcel(id: number): Promise<any> {
        return rpService.exportRPPListExcel(id)
    }

    getExpressList(page: number): Promise<any> {
        return rpService.getExpressList(page)
    }

    generateExpressRP(): Promise<void> {
        return rpService.generateExpressRP()
    }

    exportExpressRPKListExcel(id: number): Promise<any> {
        return rpService.exportExpressRPKListExcel(id)
    }
}

export const rp = new RPRealisation()
